// React Imports
import * as React from 'react';
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import {Stack, Tooltip} from "@mui/material";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DescriptionIcon from '@mui/icons-material/Description';
import {styled} from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import ListIcon from "@mui/icons-material/List";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import SearchIcon from "@mui/icons-material/Search";

// App Imports
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import WorkQueueHeader from "./WorkQueueHeader";
import WorkQueueBody from "./WorkQueueBody";


// main function
export default function WorkQueueFrame(props) {


    const controlsCardState = useSelector((state) => state.workQueueSlc.value.cardsState);
    const controlsBulkEditState = useSelector((state) => state.workQueueSlc.value.bulkEditGridState);

    const selectorExperience = useSelector((state) => state.workQueueSlc.value.workQueueExperience);




    return (
        <div>
            {(controlsBulkEditState === false &&
                    selectorExperience !== "Friendly"
                ) &&

            <WorkQueueHeader/>}
            <WorkQueueBody/>

            <div>

            </div>

            <div>

            </div>
            {/*// ************************************* BEGIN BODY ***************************************/}
            {/*// ****************************************************************************************/}



            <Box
                sx={{
                    // width: 600,
                    height: 30,
                    paddingLeft: 3
                }}/>

            {(controlsCardState === false) &&
                <div>
                <Stack>
                    < Stack direction="row" spacing={2}>
                        <Box
                            sx={{
                                width: 550,
                                height: 800,
                                flexGrow: 2,
                                backgroundColor: 'primary.white',
                            }}
                        >
                        </Box>
                    </Stack>
                </Stack>
                </div>}
            <CrudSnackbar/>
        </div>

    );

}
